import { type ChangeEvent } from 'react'

import { Select } from 'slab'

interface PartnerAdminRelationshipRoleSelectorProps {
  currentRole: string
  onChange: (role: string) => void
  hasExistingAssignee: boolean
  disabled?: boolean
  label?: string
  hideLabel?: boolean
  onBlur?: () => void
}

const ROLE_OPTIONS = [
  { value: 'viewer', label: 'Viewer' },
  { value: 'editor', label: 'Editor' },
  { value: 'assignee', label: 'Assignee' },
]

export const PartnerAdminRelationshipRoleSelector = ({
  currentRole,
  onChange,
  hasExistingAssignee,
  disabled = false,
  label = 'Role',
  hideLabel = false,
  onBlur,
}: PartnerAdminRelationshipRoleSelectorProps) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value)
  }

  return (
    <div className='relative'>
      <Select
        label={hideLabel ? undefined : label}
        value={currentRole}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        className='text-sm'
      >
        {ROLE_OPTIONS.map((option) => {
          const isAssigneeDisabled = option.value === 'assignee' && hasExistingAssignee && currentRole !== 'assignee'

          return (
            <option
              key={option.value}
              value={option.value}
              disabled={isAssigneeDisabled}
            >
              {option.label}
            </option>
          )
        })}
      </Select>
    </div>
  )
}
